module.exports = __webpack_public_path__ + "img/VU.bdbb913b.png";